import React, { useContext } from 'react';
import { map, sortBy, filter, isEmpty } from "lodash";
import SvgIcon from "../../../../../../common/components/svg-icon";
import { FocusBaseContext } from '../../../contexts';
import Note from '../../../../../../express/researcher/common/summaryPanelWithEditing/note';
import Reaction from './reaction';

const Index = () => {
  const {
    currentSummary, selectedConceptId, regions, aiSummaries, focus
  } = useContext(FocusBaseContext);

  const currentConceptId = selectedConceptId();
  const sortedRegions = sortBy(regions, (item) => item.id);
  const summaries = filter(aiSummaries, (el) => (
    el.source_id === currentConceptId && el.source_type === 'Focus::Concept' && !isEmpty(el.raw_data)
  ));
  const titleByTag = (tag) => (focus.ai_summaries_tag_titles[tag]);

  return (
    <div className="summary-ai">
      <div className="summary-panel -multi comparisons_plate -bordered -dark -js-scorecard">
        <div>
          <SvgIcon name="scheme" />
        </div>

        <div className="summary-list">
          <ul>
            {currentSummary.allowed_reactions.positive &&
              <Reaction
                fullTitle={ titleByTag('positive-all') }
                conceptId={ currentConceptId }
                tag="positive-all"
              />}
            {currentSummary.allowed_reactions.negative &&
              <Reaction
                fullTitle={ titleByTag('negative-all') }
                conceptId={ currentConceptId }
                tag="negative-all"
              />}
            {currentSummary.allowed_reactions.confusing &&
              <Reaction
                fullTitle={ titleByTag('confusing-all') }
                conceptId={ currentConceptId }
                tag="confusing-all"
              />}
            {
              map(sortedRegions, (item) => {
                return (
                  <Reaction
                    key={ `region-${item.id}` }
                    title={ item.name }
                    conceptId={ currentConceptId }
                    tag={ `region_${item.id}` }
                    region={ item }
                  />
                );
              })
            }
            {
              !!summaries.length &&
              <li>
                <Note className="-no-margin" count={ summaries.length } />
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Index;
